// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#828cff',
        secondary: '#f0f0f0',
        accent: '#204165',
        nightBlue: '#828cff',
        green: '#6db640',
        blue: '#74bfeb',
        violet: '#f879bb',
        red: '#ff3019',
        turquoise: '#31bca4',
        yellow: '#ffff00',
        white: '#ffffff',
        logo: '#000000',
        signatureBg: '#828cff',
      },
      dark: {
        primary: '#828cff',
        secondary: '#f0f0f0',
        accent: '#204165',
        nightBlue: '#828cff',
        green: '#6db640',
        blue: '#74bfeb',
        violet: '#f879bb',
        red: '#ff3019',
        turquoise: '#31bca4',
        yellow: '#ffff00',
        white: '#ffffff',
        logo: '#000000',
        signatureBg: '#828cff',
      },
    },
  },
})
